import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-modal-categorias-empresas",
  templateUrl: "./modal-categorias-empresas.page.html",
  styleUrls: ["./modal-categorias-empresas.page.scss"],
})
export class ModalCategoriasEmpresasPage implements OnInit {
  @Input() categorias: any[];

  constructor(public modalCtrl: ModalController) {}
  ngOnInit(): void {}
  selectCategoria(categoria) {
    this.modalCtrl.dismiss(categoria);
  }
}
